export default __webpack_public_path__ + "static/media/EndMillTableImg.a5ac7ffe.jpg";